import React from "react";

const ToggleAuthMode = ({ isCreating, setIsCreating }) => (
  <p className="toggle-mode">
    {isCreating ? (
      <>
        Already have an account?{' '}
        <span
          onClick={() => setIsCreating(false)}
          style={{ cursor: 'pointer', color: '#007bff' }}
        >
          Log In
        </span>
      </>
    ) : (
      <>
        Don’t have an account?{' '}
        <span
          onClick={() => setIsCreating(true)}
          style={{ cursor: 'pointer', color: '#007bff' }}
        >
          Create one
        </span>
      </>
    )}
  </p>
);

export default ToggleAuthMode;
